import { DocumentInfo, DocumentView } from "@/types/document";

export const matchesDocumentView = (
  doc: DocumentInfo,
  view: DocumentView
): boolean => {
  switch (view) {
    case "ready":
      if (doc.status === "importing" && doc.studentId) {
        return false;
      }

      return (
        doc.status === "ready" ||
        doc.status === "in_progress" ||
        doc.status === "importing" ||
        doc.status === "failed"
      );
    case "done":
      return doc.status === "done";
    case "flagged":
      return doc.status === "flagged";
    case "archived":
      return doc.status === "archived";
    default:
      return false;
  }
};
